import { render, staticRenderFns } from "./Middle.vue?vue&type=template&id=44864550"
import script from "./Middle.vue?vue&type=script&lang=js"
export * from "./Middle.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports